import { render, staticRenderFns } from "./CustomerDetailsSocialInsurance.vue?vue&type=template&id=7f9b446a"
import script from "./CustomerDetailsSocialInsurance.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsSocialInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports